import { api } from './index';

const BASE_PATH = '/api/internal/bulk_exports';

export type RecordsBulkExportType = 'charges' | 'payments';
export type BulkExportType = RecordsBulkExportType | 'calendar';
export type BulkExportStatus = 'pending' | 'processing' | 'completed' | 'failed';

export type BulkExport = {
  id: number;
  exportType: BulkExportType;
  status: BulkExportStatus;
  processedCount: number;
  totalCount: number;
  errorMessage: string | null;
}

export interface RecordsBulkExportForm {
  exportType: RecordsBulkExportType;
  fromDate: string;
  toDate: string;
  recordIds: number[];
}

export type CalendarDateFilter = 'today' | 'weekly' | 'monthly';

export interface CalendarBulkExportForm {
  exportType: 'calendar';
  groupBy: 'patient' | 'caregiver';
  startDateTimeFilter: CalendarDateFilter;
  offset?: number;
  caregiverCareerIn?: string[];
  patientGroupsIdIn?: number[];
  priceFilter?: string;
  costFilter?: string;
  markedStatusFilter?: string;
  // Also print the weekly-plan visits no shift covers ("Por asignar").
  includeRequirements?: boolean;
}

export type BulkExportForm = RecordsBulkExportForm | CalendarBulkExportForm;

export const bulkExportsApi = {
  create(bulkExportForm: BulkExportForm): Promise<BulkExport> {
    return api({
      method: 'post',
      url: BASE_PATH,
      data: { bulkExport: bulkExportForm },
    }).then(response => response.data.bulkExport);
  },
  show(id: number): Promise<BulkExport> {
    return api({
      method: 'get',
      url: `${BASE_PATH}/${id}`,
    }).then(response => response.data.bulkExport);
  },
  downloadPath(id: number): string {
    return `${BASE_PATH}/${id}/download`;
  },
};
